import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Button, List, ListItem, ListItemButton,
  ListItemText, TextField, Paper, Autocomplete, Grid
} from '@mui/material';
import Swal from 'sweetalert2';
import GestionObjetivo from './GestionObjetivos';
import GestionGasto from './GestionGasto';
import { useUser } from '../contexts/UserContext';
import { event } from 'jquery';
import { useAccesos } from '../contexts/AccesosContext';

 function AddCampaña({ handleNewCampania, editCampania, cancelarEdicion, actualizarCampania}) {
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  const [seccionSeleccionada, setSeccionSeleccionada] = useState('Campaña');

  // Form states por separado si quieres manejar inputs
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [fechaInicio, setfechaInicio] = useState('');
  const [fechaFinalizacion, setfechaFinalizacion] = useState('');
  const [estadoSeleccionado, setEstadoSeleccionado] = useState('');
  const [promocionSeleccionada, setPromocionSeleccionada] = useState(null);
  const [campania, setCampania] = useState('');
  const [modificacion, setModificacion] = useState('');
  const [estados, setEstados] = useState([]);
  const [promociones, setPromociones] = useState([]);
  const [IngresadoPor, setIngresadoPor] = useState('');
  const [objetivos, setObjetivos] = useState(['']);
  const [gastos, setGastos] = useState([{ nombre: '', monto: '' }]);

  const { user } = useUser();
  const { tienePermiso } = useAccesos();
    // Obtener la fecha y hora actual
    function obtenerFechaISOsinZ() {
      const fecha = new Date();
      let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
      fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
      return fechaISO;
  }

    const fetchGastosPorCampania = async (idCampania) => {
      try {
        const response = await fetch(`${server}/CrmGastoCampaniums/poridCampania/${idCampania}`);
        const data = await response.json();
        setGastos(data.$values || []);
      } catch (error) {
        console.error("Error al obtener gastos:", error);
      }
    };

    const fetchObjetivosPorCampania = async (idCampania) => {
      try {
        const response = await fetch(`${server}/CrmObjetivoCampaniums/poridCampania/${idCampania}`);
        const data = await response.json();
        setObjetivos(data.$values || []);
      } catch (error) {
        console.error("Error al obtener objetivos:", error);
      }
    };

   const fetchEstadosCampania = async () => {
                try {
                    const response = await fetch(`${server}/CrmEstadoCampaniums`); 
                    const data = await response.json();
                    setEstados(data.$values);
                } catch (error) {
                    console.error('Error al cargar los estados de campania:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar los Estados de campania: ' + error,
                    });
                }
            };

    const fetchPromociones = async () => {
                try {
                    const response = await fetch(`${server}/PrPromociones`); 
                    const data = await response.json();
                    setPromociones(data.$values);
                } catch (error) {
                    console.error('Error al cargar las promociones:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar las promociones: ' + error,
                    });
                }
            };

        useEffect(() => {
          fetchEstadosCampania();
          fetchPromociones();
        }, []);
 // Convertir a una cadena en formato ISO 8601
    const fechaFormateada = obtenerFechaISOsinZ();
    // Carga inicial de datos si estamos en modo edición
      useEffect(() => {
        if (editCampania && estados.length && promociones.length) {
          setNombre(editCampania.tituloCampania);
          setDescripcion(editCampania.decripcionCampania); // Cargar la descripción de la raza para editar
          setfechaInicio(editCampania.fechaInicio);
          setfechaFinalizacion(editCampania.fechaFinalizacion);

          const estadoMatch = estados.find(e => e.id === editCampania.idEstadoCampania);
          const promoMatch = promociones.find(p => p.id === editCampania.idPromocion);

          setEstadoSeleccionado(estadoMatch || null);
          setPromocionSeleccionada(promoMatch || null);
          setModificacion(2);
          setIngresadoPor(editCampania.ingresadoPor);
          
          //  Cargar objetivos y gastos asociados
          fetchGastosPorCampania(editCampania.idCampania);
          fetchObjetivosPorCampania(editCampania.idCampania);
      
        } else {
          setNombre('');
          setDescripcion(''); // Resetear la descripción si no estamos editando
          setfechaInicio('');
          setfechaFinalizacion('');
          setEstadoSeleccionado('');
          setPromocionSeleccionada(null);
          setModificacion(1);
          setIngresadoPor('');
      
        }
    }, [editCampania]);



    const handleSubmit = async (e) => {
            e.preventDefault();
            const method = editCampania? 'PUT' : 'POST'; // Usar PUT para actualizar y POST para crear
            const endpoint = editCampania ? `${server}/CrmCampaniums/${editCampania.idCampania}` : `${server}/CrmCampaniums`;
    
            const campania = { 
                idCampania:editCampania ? editCampania.idCampania:0,
                tituloCampania: nombre,
                decripcionCampania: descripcion,
                fechaInicio,
                fechaFinalizacion,
                idEstadoCampania: estadoSeleccionado?.id || null,
                idPromocion: promocionSeleccionada?.id || null,
                IngresadoPor: !editCampania ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
                ModificadoPor: editCampania ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
                modificacion,
                fechaIngreso: fechaFormateada
            };

            Object.keys(campania).forEach(key => campania[key] === undefined && delete campania[key]);
            console.log('Datos enviados a la API:', campania);
            console.log(endpoint)
            try {
                const response = await fetch(endpoint, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(campania),
                });
    
                if (response.ok) {
                    // Limpiar el formulario y manejar la respuesta si es necesario
                    setNombre('');
                    setDescripcion('');
                    setfechaInicio('');
                    setfechaFinalizacion('');
                    setEstadoSeleccionado('');
                    setPromocionSeleccionada(null);
                    setModificacion(1);
                    setIngresadoPor('');
                    Swal.fire({
                        icon: 'success',
                        title: 'Operación exitosa',
                        showConfirmButton: false,
                        timer: 1500
                    });         
                    handleNewCampania();
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });            }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar la Campaña',
                    text: error || 'Ocurrió un error inesperado',
                });        }
        };



  const renderContenido = () => {
    switch (seccionSeleccionada) {
      case 'Campaña':
        return (
          <Box component="form" onSubmit={handleSubmit}>
            <Typography variant="h6">Detalles de la Campaña</Typography>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextField
                    fullWidth
                    label="Nombre de la Campaña"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    sx={{ mt: 2 }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                    fullWidth
                    label="Descripcion de la Campaña"
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                    sx={{ mt: 2 }}
                    />
                </Grid>
                <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="Fecha de Inicio"
                    type="date"
                    value={fechaInicio}
                    sx={{ mt: 2 }}
                    onChange={(e) => setfechaInicio(e.target.value)}
                    InputLabelProps={{
                    shrink: true,  
                }}
                />
                </Grid>
                <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="Fecha de Finalización"
                    type="date"
                    value={fechaFinalizacion}
                    sx={{ mt: 2 }}
                    onChange={(e) => setfechaFinalizacion(e.target.value)}
                    InputLabelProps={{
                    shrink: true, 
                    
                }}
                />
                </Grid>
                <Grid item xs={6}>
                <Autocomplete
                    options={estados}
                    getOptionLabel={(option) => option?.estado || ''}
                    value={estadoSeleccionado}
                    onChange={(event, newValue) => setEstadoSeleccionado(newValue)}
                    renderInput={(params) => <TextField {...params} 
                    label="Estado" 
                    fullWidth
                    sx={{ mt: 2 }}
                />}     
                />
                </Grid>
                <Grid item xs={6}>
                < Autocomplete
                    options={promociones}
                    getOptionLabel={(option) => option?.descripcion || ''}
                    value={promocionSeleccionada}
                    onChange={(event, newValue) => setPromocionSeleccionada(newValue)}
                    renderInput={(params) => <TextField {...params} 
                    label="Promocion asociada" 
                    fullWidth
                    sx={{ mt: 2 }}
                />}
                />
                </Grid>
                
                <Grid item xs={12} sx={{mt: 3}}>
                  <Button type="submit" variant="contained" color="success" disabled={!tienePermiso('Crear Campaña')}>
                    {editCampania ? 'Actualizar' : 'Guardar'}
                  </Button>
                  
                  {editCampania && (
                    <Button type="button" variant="contained" color="secondary" onClick={handleCancelarEdicion}>
                      Cancelar
                    </Button>
                  )}
                </Grid>
            </Grid>
          </Box>
          
          
          
        );
        
      case 'Objetivos':
        return (
          <Box>
            <Typography variant="h6"></Typography>
              <GestionObjetivo idCampania={editCampania?.idCampania} objetivos={objetivos} onUpdate={handleNewCampania}/>
          </Box>
        );
      case 'Gastos':
        return (
          <Box>
            <Typography variant="h6"></Typography>
                <GestionGasto idCampania={editCampania?.idCampania} gastos={gastos} onUpdate={actualizarCampania}/>
          </Box>
        );
      default:
        return null;
    }
  };


  const handleCancelarEdicion = () => {
    setNombre('');
    setDescripcion('');
    setfechaInicio('');
    setfechaFinalizacion('');
    setEstadoSeleccionado('');
    setPromocionSeleccionada(null);
    setModificacion(1);
    setIngresadoPor('');
    if (cancelarEdicion) cancelarEdicion();
  }

  return (
    <div>
    <Box sx={{ display: 'flex', height: '100%', mt: 4, pb: 7  }}>
      {/* Sidenav */}
      <Paper elevation={3} sx={{ width: 220, mr: 3, p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>Secciones</Typography>
        <List>
          {['Campaña', 'Objetivos', 'Gastos'].map((seccion) => (
            <ListItem key={seccion} disablePadding>
              <ListItemButton
                selected={seccionSeleccionada === seccion}
                onClick={() => setSeccionSeleccionada(seccion)}
              >
                <ListItemText primary={seccion} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>

      {/* Contenido derecho */}
      <Paper elevation={3} sx={{ flex: 1, p: 3 }}>
        {renderContenido()}
      </Paper>
      
    </Box>
    
        </div>

    
  );
}

export default AddCampaña;